import './polyfills';
import { Provider } from 'react-redux';
import { configureStore } from './utils/configureStore';
import { startApp } from './actions/AppActions';
import { Routes } from './components/Routes';
import { ApplicationWrapper } from './components/ApplicationWrapper';
import { View } from 'foundations-components/components/View';
import { getPreferredLocale } from './i18n/localeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = () => {
  const store = configureStore();
  store.dispatch(startApp());
  return {
    props: {
      store
    }
  };
};
export const getLocaleInfo = () => {
  return {
    locale: getPreferredLocale(),
    langEnabled: true
  };
};
export function AppComponent({
  store
}) {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-transparent-default",
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(ApplicationWrapper, {
        children: /*#__PURE__*/_jsx(Routes, {})
      })
    })
  });
}